module.exports = __webpack_public_path__ + "static/img/63.54b28b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/63.jpg
// module id = xqyx
// module chunks = 0